import moment from "moment-timezone"
import { formatTimezone, parseSFTimezone } from './accounts';

export const nameToInitial = (name: string | null) => {
  if (!name) return ''
  const splitName = name.split(' ')
  let initial = splitName[0][0]
  if (splitName.length > 1) {
    initial += splitName[splitName.length - 1][0]
  }

  return initial
}

export const formatDate = (dateString?: string | null, format?: string, tz?: string | null) => {
  if (!dateString) return dateString

  const f: string = format || 'MM/DD/YYYY'

  return tz ? moment.tz(dateString, tz).format(f) : moment(dateString).format(f)
}

export type TimezoneParts = {
  timezoneCode: string,
  timezoneName: string,
}

export const getPartsFromAccountTz = (accountTimezone?: string | null): TimezoneParts => {
  const parsedTimezone = parseSFTimezone(accountTimezone ?? 'US/Pacific');

  return {
    timezoneCode: parsedTimezone.code,
    timezoneName: parsedTimezone.name,
  };
};

export const secondsToHoursMinuteSecond = (seconds?: number | null) => {
  if (!seconds) return '00:00:00'

  const roundedSeconds = Math.round(seconds)
  const hours = Math.floor(roundedSeconds / (60 * 60)).toString().padStart(2, '0')
  const minutes = Math.floor((roundedSeconds % (60 * 60)) / 60).toString().padStart(2, '0')
  const remainingSeconds = Math.floor((roundedSeconds % (60 * 60)) % 60).toString().padStart(2, '0')

  return `${hours}:${minutes}:${remainingSeconds}`
}

export const secondsToMinuteSecond = (seconds?: number | null) => {
  if (!seconds) return '0:00'

  const roundedSeconds = Math.round(seconds)
  const minutes = Math.floor(roundedSeconds / 60)

  return `${minutes}:${Math.floor(roundedSeconds % 60).toString().padStart(2, '0')}`
}

export function removeLeadingPlus (num?: string) {
  if (!num) return num

  const trimmedNum = num.trim()
  return trimmedNum[0] === '+' ? trimmedNum.replace('+', '') : trimmedNum
}

// https://stackoverflow.com/a/274094
function regexIndexOf(string: string, regex: RegExp, startpos: number) {
  var indexOf = string.substring(startpos || 0).search(regex)
  return (indexOf >= 0) ? (indexOf + (startpos || 0)) : indexOf
}

export const highlightHtml = (htmlString: string, searchString: string) => {
  const regEscape = (v: string) => v.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&')

  let currentIndex = -1
  let foundIndex = regexIndexOf(htmlString, new RegExp('(?<!<[^>]*)' + regEscape(searchString), 'ig'), 0)
  const foundIndexes = []
  while (foundIndex > currentIndex) {
    foundIndexes.push(foundIndex)
    currentIndex = foundIndex
    foundIndex = regexIndexOf(htmlString, new RegExp('(?<!<[^>]*)' + regEscape(searchString), 'ig'), currentIndex)
  }

  const textLength = searchString.length
  let highlightedHtml = htmlString
  // Work from the last so the leading indexes does not get messed up
  foundIndexes.reverse().forEach(index => {
    highlightedHtml = highlightedHtml.slice(0, index) +
      `<mark>${highlightedHtml.slice(index, index + textLength)}</mark>` +
      highlightedHtml.slice(index + textLength)
  })

  return highlightedHtml
}

export interface AppLog {
  timestamp: number,
  log: string,
}

export enum ViewRoute {
  RECEPTIONIST_VIEW = '/receptionist',
  ACTIVITY_VIEW = '/activity',
}

export const stringContainsHtmlTags = (str: string) => {
  const regex = new RegExp(/<[^>]*>/g)
  return regex.test(str)
}

export const removeLastWord = (title: string, word: string, exceptions: string[] = []): string => {
  if (!title || !word) return title; // Handle edge cases

  // Check if the title matches any of the exception phrases
  if (exceptions.some(exception => title.endsWith(exception))) {
    return title; // Do nothing if the title matches an exception
  }

  // Remove the word only if it appears at the end of the string
  const regex = new RegExp(`\\b${word}\\b$`, 'i'); // Case-insensitive matching
  return title.replace(regex, '').trim();
};
